module.exports = __webpack_public_path__ + "static/kiara-50d8da3bdced1009f87bd853ca1bf3f6.png";